// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"by","header":"bz","overTitle":"bA","image":"bB","title":"bC","description":"bD","button":"bE"};